export const NavBar = () => {
  return (
    <nav className="navbar bg-black text-light mb-5 p-3">
        <div className="mx-auto">
            <h1 className="m-0">MeteoPro</h1>
            <h5 className="text-primary">Tu pronóstico personalizado</h5>
        </div>
          
    </nav>
  )
}
